{
  "title": "How to View a Submission's Scores",
  "description": "View every judge's current score and review comment for a specific submission.",
  "headings": [
    "What You'll Accomplish",
    "Applies To",
    "Before You Start",
    "Steps",
    "What You'll See",
    "FAQ"
  ],
  "summary": "When you're done, you can see every judge's current scoring status, total score, and review comment for a specific submission.",
  "roleNote": "Competition Admin / staff with score-viewing access",
  "prerequisites": [
    "You hold score-viewing access (score.read; held by competition admins and staff)"
  ],
  "pathLabel": "Organizer Console → Submissions → Submission Detail",
  "steps": [
    {
      "title": "1. Open the submission's detail page",
      "description": "In the submissions list, click the submission you want to view to open its detail page."
    },
    {
      "title": "2. View the score list",
      "description": "The detail page lists every currently assigned judge's scoring record for this submission, including judge name, scoring status (not started / draft / locked), total score, and review comment; sorted newest-updated first."
    },
    {
      "title": "3. Decide whether intervention is needed",
      "description": "If you spot an unusual score, a concerning review comment, or need to handle a scoring dispute or conflict-of-interest check, use this page's information to decide whether the score needs to be \"reopened\" for the judge to revise."
    }
  ],
  "afterward": [
    "You have a clear view of a single submission's complete scoring status",
    "This page never shows a judge's private scoring notes to themselves — only the review comment intended for the organizer to see"
  ],
  "nextSteps": "If a judge needs to revise an already-submitted score, see the existing \"Reopen Score\" operation; once every submission is fully scored, see \"How to Calculate, Lock, and Publish Results\".",
  "faq": [
    {
      "q": "Can this page show a judge's private notes to themselves?",
      "a": "No. This page deliberately only shows the \"review comment\" field (intended for the organizer's eyes) — a judge's own private scoring notes never appear here, so a judge's private notes stay private from the organizer."
    },
    {
      "q": "Is score-viewing access the same as score-management access?",
      "a": "No. Viewing score content (score.read) and managing scoring actions (e.g. reopening) are two separate capabilities — having one does not imply the other."
    },
    {
      "q": "Can I view every submission's review comments in the competition at once?",
      "a": "Yes. On the Results page every row has a \"View judges' review comments\" section (plus an \"Expand all review comments\" toggle). To get the whole competition in one file, download the \"Scores & review comments\" report from the Export Center (one row per judge per submission, never including judges' private notes)."
    }
  ]
}
